<template>
    <b-form-input v-model="text" :value="text" class="apprentice-input-field with-border rating-custom-name-input" placeholder="optionele naam" @input="updateInput"></b-form-input>
</template>

<script>
    export default {
        name: "design-2021-group-show-rating-custom-title-input-component",
        props: {
            value: String,
        },

        data() {
            return {
                text: this.value,
            }
        },

        methods: {
            updateInput(){
                this.$emit('input', this.text);
            }
        }
    }
</script>

<style scoped lang="scss">
    .rating-custom-name-input {
        border: 1px solid $border-color;
        margin-bottom: 0;
    }
</style>
